const logo = {
    templateUrl: '/modules/common/logo/logo.html',
    controller: 'LogoController',
};

angular
    .module('logo.module', [])
    .component('logo', logo);